export default __webpack_public_path__ + "images/0x28a92dde19d9989f39a49905d7c9c2fac7799bdf.png";